import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useMemo, useState } from "react";
import { useParams, useSearchParams, useLocation } from "react-router-dom";
import { useTranslation } from "@i18n";
import Layout from "@/_LayoutsRelated/layout/Layout";
import Questions from "@/pages/survey/survey/Questions/Questions";
import AfterSubmitComp from "@/pages/survey/survey/AfterSubmitComp/AfterSubmitComp";
import { CDN_LINK } from "@globalConfig";
import useHelpers from "@hooks/useHelpers";
import useApi from "@hooks/useApi";
import { api__getSurveyData } from "@/apis/survey/survey";
import Loader from "@componentsShared/Loader/Loader";
var Survey = function Survey() {
  var _searchParams$get;
  var _useTranslation = useTranslation(["web_survey"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useParams = useParams(),
    order_id = _useParams.order_id;
  var _useSearchParams = useSearchParams(),
    _useSearchParams2 = _slicedToArray(_useSearchParams, 1),
    searchParams = _useSearchParams2[0];
  var _useState = useState(false),
    isSurveyDone = _useState[0],
    setIsSurveyDone = _useState[1];
  var location = useLocation();
  var isCancelled = useMemo(function () {
    return location.pathname.includes("cancelled");
  }, [location.pathname]);
  var _useApi = useApi([], function () {
      return api__getSurveyData(order_id, searchParams.get("finance"), isCancelled);
    }),
    _useApi2 = _slicedToArray(_useApi, 3),
    loading = _useApi2[0],
    error = _useApi2[1],
    surveyData = _useApi2[2];
  useEffect(function () {
    if (!order_id) navigateTo("/?ref=survey_no_order_id");
  }, []);
  useEffect(function () {
    if (error) {
      navigateTo("/?ref=survey_failed_to_get_data_or_404");
    }
  }, [error]);
  if (loading) return /*#__PURE__*/React.createElement(Layout, null, /*#__PURE__*/React.createElement(Loader, null));
  return /*#__PURE__*/React.createElement(Layout, {
    hideOrangeHeadBtn: true,
    hideFooter: true,
    hideSideMenue: true,
    hideAppBanner: true
  }, surveyData !== null && surveyData !== void 0 && surveyData.is_complete ? /*#__PURE__*/React.createElement(AfterSubmitComp, {
    imgPath: CDN_LINK + "/assets/images/survey_already_applied_msg.svg",
    title: t("already_filled_questionnaire", {
      ns: "web_survey"
    }),
    message: t("appreciate_feedback_help_improve_service", {
      ns: "web_survey"
    }),
    buttonText: t("go_homepage", {
      ns: "web_survey"
    }),
    onClick: function onClick() {
      return navigateTo("/?ref=survey_already_done");
    }
  }) : null, isSurveyDone ? /*#__PURE__*/React.createElement(AfterSubmitComp, {
    imgPath: CDN_LINK + "/assets/images/survey_thank_you_msg.svg",
    title: t("thank", {
      ns: "web_survey"
    }),
    message: t("evaluation_important_working_improve_service", {
      ns: "web_survey"
    }),
    buttonText: t("go_homepage", {
      ns: "web_survey"
    }),
    onClick: function onClick() {
      return navigateTo("/?ref=survey_done");
    },
    hasClassDone: true
  }) : (surveyData === null || surveyData === void 0 ? void 0 : surveyData.question) && /*#__PURE__*/React.createElement(Questions, {
    order_id: order_id,
    questionsCount: surveyData.questions_count,
    questions: surveyData.question,
    survey_id: surveyData.survey_id || surveyData.surveyId || surveyData.id,
    username: surveyData.customer_name,
    commonG4Data: surveyData.g4_data,
    setIsSurveyDone: setIsSurveyDone,
    isCancelled: isCancelled ? 1 : 0,
    isFinance: (_searchParams$get = searchParams.get("finance")) !== null && _searchParams$get !== void 0 ? _searchParams$get : 0
  }));
};
export default Survey;